import { AsyncPipe, CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { ToastModule } from 'primeng/toast';
import { Observable, catchError, of, tap } from 'rxjs';
import { AppsMobileComponent } from 'src/app/components/apps-mobile/apps-mobile.component';
import { App } from 'src/app/models/app.model';
import { AppService } from 'src/app/services/app.service';
import { generateSlug } from 'src/app/services/utils.service';

@Component({
  selector: 'uvema-home',
  templateUrl: './home.component.html',
  imports: [
    ReactiveFormsModule,
    CommonModule,
    AsyncPipe,
    AppsMobileComponent,
    ButtonModule,
    DialogModule,
    InputTextModule,
    ToastModule,
    PasswordModule,
  ],
  providers: [AppService, MessageService],
  standalone: true,
})
export class HomeComponent implements OnInit {
  apps$: Observable<App[]>;

  constructor(
    private appService: AppService,
    private fb: FormBuilder,
    private messageService: MessageService,
    private afs: AngularFirestore,
  ) {
    localStorage.clear();
  }

  form = this.fb.group({
    name: ['', [Validators.required]],
    stripe_pub_key: ['', [Validators.required]],
    stripe_pv_key: ['', [Validators.required]],
    jitsi_server_url: ['', [Validators.required]],
    jitsi_api_key: ['', [Validators.required]],
  });
  viewModal: boolean = false;
  loading: boolean = false;

  ngOnInit(): void {
    this.apps$ = this.appService.findApps();
  }

  addApp() {
    this.viewModal = true;
  }

  onSubmit() {
    this.form.markAllAsTouched();
    if (!this.form.valid) {
      return;
    }
    const data = { ...this.form.value } as App;
    data.slug = generateSlug(data.name);
    this.appService
      .createApp(data, this.afs.createId())
      .pipe(
        tap((app) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: `App ${app.name} creada`,
            life: 3000,
          });
          this.viewModal = false;
          this.form.reset();
        }),
        catchError((error) => {
          console.error('Error al crear la app:', error);
          return of(null);
        }),
      )
      .subscribe();
  }

  get nameIsInvalid() {
    return (
      this.form.controls.name.touched &&
      this.form.controls.name.dirty &&
      this.form.controls.name.invalid
    );
  }
  get stripePupkeyIsInvalid() {
    return (
      this.form.controls.stripe_pub_key.touched &&
      this.form.controls.stripe_pub_key.dirty &&
      this.form.controls.stripe_pub_key.invalid
    );
  }
  get stripePrivateKeyIsInvalid() {
    return (
      this.form.controls.stripe_pv_key.touched &&
      this.form.controls.stripe_pv_key.dirty &&
      this.form.controls.stripe_pv_key.invalid
    );
  }

  get jitsiServerUrlIsInvalid() {
    return (
      this.form.controls.jitsi_server_url.touched &&
      this.form.controls.jitsi_server_url.dirty &&
      this.form.controls.jitsi_server_url.invalid
    );
  }

  get jitsiApiKeyIsInvalid() {
    return (
      this.form.controls.jitsi_api_key.touched &&
      this.form.controls.jitsi_api_key.dirty &&
      this.form.controls.jitsi_api_key.invalid
    );
  }
}
